import React, {useState,useEffect} from 'react';
import { connect } from 'react-redux'
import ZoneForm from './ZoneForm'
import * as actionCreators from '../../store/actions/index'
import axios from '../../http-config';
import _ from 'lodash'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import {Link} from 'react-router-dom'
function ZoneEdit (props){
 
    const [singleZone, setZone] = useState({}); 

    useEffect(() => {
        const payload = {
            token : props.token,
            id    : props.match.params.id
        }
        const url = `/zone/${payload.id}`
        axios({
                method   : 'get',
                url      : url,
                headers  : {'Authorization': `Bearer ${payload.token}`}
                })
                .then((response) => {
                 setZone(response.data.data.zones[0])
                })
                .catch((err) => {
                    
                })
      },[]);
    
    const handleSubmit = (formdata)=>{
        props.onEditZone(formdata,props)
    }
    return (
        <div>
            <div className="create_ulb">
                <div className="dashboard_top_path">
                    <p><img src="images/left-arrow.svg" /> Zone Management / <span>Edit Zone</span></p>
                </div>
                <div className="dashboard_right_content">
                    <img className="dashboard_right_content_top_icon" src="images/Rectangle.svg" />
                    <div className="dashboard_right_content_top">
                    <h5><Link to = "/zone-management" className="email_link"><ArrowBackIosIcon></ArrowBackIosIcon></Link>Edit Zone</h5>
                    </div>
                    <div className="create_ulb_content_outer">
                        <div className="create_ulb_content">
                            {
                                !_.isEmpty(singleZone) && (
                                    <ZoneForm {...singleZone} handleSubmit={handleSubmit}/>
                                )
                            }
                           
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    )
    
}

const mapStateToProps = (state) => ({
    token:state.auth.token
})

const mapDispatchToProps = (dispatch) => {
    return({
        onEditZone : (payload,props) => dispatch(actionCreators.editZone(payload,props))
    })
}

export default connect(mapStateToProps, mapDispatchToProps)(ZoneEdit)

